import { TopPageView } from './TopPageView'
import { withTopPageView } from './withTopPageView'

const ConnectedTopPageView = withTopPageView(TopPageView)
export { ConnectedTopPageView as TopPageView }
